export default __webpack_public_path__ + "static/media/background.8359c919.jpg";